<template>
  <div class="form">
    <h4 class="has-text-weight-bold is-size-6 has-padding-bottom-1">Neuer Unterordner</h4>
        <transition name="fade">
            <div class="notification is-danger" v-if="(error === 'server')">
                {{ errorMessage }}
            </div>
        </transition>
      <div class="field is-horizontal">
          <div class="field">
              <div class="control">
                  <input type="text" class="input" :class="(missingName) ? 'is-danger' : ''" placeholder="Name" v-model="name">
                  <p class="help" v-if="missingName">Der Name ist notwendig</p>
              </div>
          </div>
          <div class="field">
              <div class="control">
                  <button class="button is-primary" :class="(loading) ? 'is-loading' : '' || (success) ? 'is-success' : ''" :disabled="missingName" @click="addFolder" >
                    <i v-if="(error === 'server')"
                        class="fa fa-exclamation-circle is-error"></i>
                    <i v-if="success" class="fa fa-success"></i>
                    Erstellen</button>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    props: ['parent'],
    data: function() {
        return {
            name: '',
            error: '',
            errorMessage: '',
            loading: false,
            success: false
        }
    },
    computed: {
        missingName: function () {
            return this.name === '';
        }
    },
    methods: {
        addFolder() {
            this.loading = true;

            if (this.name === '') {
                this.error = 'name'
            }

            let data = new FormData;

            data.append('name', this.name);
            data.append('parent', this.$props.parent);

            axios.post('/folders/new', data)
                .then(res => {
                    this.name = '';
                    this.loading = false;
                    this.error = '';

                    if(res.status === 200) {
                        this.loading = false;
                        this.success = true;

                        return;
                    }

                    this.loading = false;
                    this.error = 'server'

                    this.errorMessage = res.data.message;
                })
                .catch(err => {
                    this.loading = false;
                    this.error = 'server'
                    this.errorMessage = err.message;
                })
        }
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckAddFolder.vue